import { List as IList, Map as IMap } from 'immutable';

import { createSelector } from 'reselect';
import { programStepCompleted } from '../program/programStepSelectors';
import { getFlowProgress, getPreferredCardType, getPreferredFaceplateCode } from '../routing/flowSelectors';
import {
    IS_SELFBUY_FIELD, newItemIsSelfBuy, RECIPIENT_NAME_FIELD, SENDER_NAME_FIELD
} from '../item/newItemForm';
import { programIsActive } from '../program/programSelectors';
import {
    faceplateForCode,
    isFaceplateDigital,
    isFaceplatePhysical,
    programPrimaryFaceplate
} from '../faceplate/faceplateSelectors';



export const recipientStepCompleted = createSelector(
    getFlowProgress,
    newItemIsSelfBuy,
    (flowState, isSelfBuy) => (
        isSelfBuy
            ? flowState.has(IS_SELFBUY_FIELD)
            : (
                flowState.has(RECIPIENT_NAME_FIELD)
                && flowState.has(SENDER_NAME_FIELD)
                && flowState.has(IS_SELFBUY_FIELD))
    )
);


export const recipientStepPreConditions = IList([
    programStepCompleted
]);


export const recipientStepPostConditions = IList([
    recipientStepCompleted
]);


export const shouldDisplayFaceplate = (state) => {
    const preferredFaceplateCode = getPreferredFaceplateCode(state);
    if (programIsActive(state)) {
        const faceplate = programPrimaryFaceplate(state);
        const showFaceplate = faceplate && faceplate.size > 0;
        return { faceplate, showFaceplate };
    }
    if (preferredFaceplateCode) {
        const preferredCardTypeIsPlastic = getPreferredCardType(state);
        if (preferredCardTypeIsPlastic !== null) {
            if (preferredCardTypeIsPlastic && isFaceplatePhysical(state)(preferredFaceplateCode)) {
                return { faceplate: faceplateForCode(state, preferredFaceplateCode), showFaceplate: true };
            }
            if (!preferredCardTypeIsPlastic && isFaceplateDigital(state)(preferredFaceplateCode)) {
                return { faceplate: faceplateForCode(state, preferredFaceplateCode), showFaceplate: true };
            }
        }
    }
    return { faceplate: IMap(), showFaceplate: false };
};
